<template>
	<div class="mb-5 has-text-weight-bold">{{ quizTitle }}</div>
	<div class="mb-4">
		<p class="is-size-6">{{ question.position_in_quiz }} out of {{ questionsPerQuiz }}</p>
	</div>
</template>

<script lang="ts">
import { QuizGetters } from '@/store/modules/quiz/getters'
import { STATE_MODULES } from '@/store/state-modules'
import { QuestionPropMixin } from '@/utils/skill-assessment-mixins'
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'

export default defineComponent({
	mixins: [QuestionPropMixin],
	computed: {
		...mapGetters(STATE_MODULES.QUIZ, {
			question: QuizGetters.GET_CURRENT_QUESTION,
			quizTitle: QuizGetters.GET_QUIZ_NAME,
			questionsPerQuiz: QuizGetters.GET_QUESTIONS_COUNT
		})
	}
})
</script>

<style scoped>

</style>
